<template>
  <div class="w-50 text-xs" :class="{ 'text-error': showDeclineSubReason }">
    {{ reason }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { PLACEMENT_STATUS_DECLINED } from "@/helpers/constants";

import type { ILenderPlacement } from "@/models/funders";
import type { IPlacementDeclineSubReason } from "@/models/options";
import type { PropType } from "vue";

const props = defineProps({
  model: {
    type: Object as PropType<ILenderPlacement>,
  },
});

const { getters } = useStore();

const declineSubReason = computed<IPlacementDeclineSubReason>(() =>
  getters["options/placementDeclineSubReasonById"](
    props.model?.decline_subreason_id
  )
);

const showDeclineSubReason = computed(
  () =>
    declineSubReason.value && props.model?.status === PLACEMENT_STATUS_DECLINED
);
const reason = computed(() =>
  showDeclineSubReason.value && declineSubReason.value?.label
    ? declineSubReason.value.label
    : "-"
);
</script>
